import { cloneElement, useCallback, useState } from 'react';
import { propBool, propChildren, propFunc, } from '../../../helpers/custom-prop-types';
const Hover = (props) => {
    const { children, enableSp, onMouseEnter: rawOnMouseEnter, onMouseLeave: rawOnMouseLeave, } = props;
    const { props: { className }, } = children;
    const [addClass, changeClass] = useState('');
    const onMouseEnter = useCallback(() => {
        changeClass('js_hover');
        if (rawOnMouseEnter) {
            rawOnMouseEnter();
        }
    }, [rawOnMouseEnter]);
    const onMouseLeave = useCallback(() => {
        changeClass('');
        if (rawOnMouseLeave) {
            rawOnMouseLeave();
        }
    }, [rawOnMouseLeave]);
    return cloneElement(children, {
        className: !className ? addClass : `${className} ${addClass}`,
        onMouseEnter,
        onMouseLeave,
        onTouchEnd: enableSp ? onMouseLeave : undefined,
        onTouchStart: enableSp ? onMouseEnter : undefined,
    });
};
Hover.propTypes = {
    children: propChildren().isRequired,
    enableSp: propBool(),
    onMouseEnter: propFunc(),
    onMouseLeave: propFunc(),
};
Hover.defaultProps = {
    enableSp: false,
    onMouseEnter: null,
    onMouseLeave: null,
};
export default Hover;
